<template>
  <Layout>
    <PageHeader :title="title" :items="braedcrumb" />
    <b-overlay :show="isBusy">
      <div class="row">
        <div class="col">
          <div class="card">
            <div class="row m-2">
              <div>
                <div>
                  <b-row>
                    <b-col sm="12" lg="2">
                      <!-- <date-picker
                        v-model="filter.StartDate"
                        format="DD.MM.YYYY"
                        style="width: 100%"
                        value-type="format"
                        :editable="true"
                        :placeholder="$t('StartDate')"
                      ></date-picker> -->
                      <custom-date-picker
                        v-model="filter.StartDate"
                        format="DD.MM.YYYY"
                        type="date"
                        :clearable="false"
                        :placeholder="$t('docdate')"
                        @keyup="BindValueStart"
                      >
                      </custom-date-picker>
                    </b-col>
                    <b-col sm="12" lg="2">
                      <!-- <date-picker
                        v-model="filter.EndDate"
                        format="DD.MM.YYYY"
                        style="width: 100%"
                        value-type="format"
                        :editable="true"
                        :placeholder="$t('EndDate')"
                      ></date-picker> -->
                      <custom-date-picker
                        v-model="filter.EndDate"
                        format="DD.MM.YYYY"
                        type="date"
                        :clearable="false"
                        :placeholder="$t('docdate')"
                        @keyup="BindValueEndDate"
                      >
                      </custom-date-picker>
                    </b-col>
                    <b-col sm="12" lg="3">
                      <b-input-group>
                        <b-form-input
                          :placeholder="$t('search')"
                          v-model="filter.Search"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button @click="Refresh" variant="primary">
                            <i class="fas fa-search"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-col>
                    <b-col sm="12" md="3" lg="3">
                      <b-button
                        class="float-right"
                        variant="primary"
                        size="md"
                        @click="Print"
                      >
                        <b-icon v-if="!PrintLoading" icon="printer"></b-icon>
                        <b-spinner v-if="PrintLoading" small></b-spinner>
                        {{ $t("Print") }}
                      </b-button>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </div>
            <div class="row m-2">
              <div class="table-container" style="overflow-x:auto;height:65vh;">
                <table
                  class="table table-bordered table-responsive stikcy-header"
                >
                  <thead>
                    <tr>
                      <b-th
                        rowspan="2"
                        variant="info"
                        width="10%"
                        style="text-align: center; vertical-align: middle"
                      >
                        {{ $t("provider") }}
                      </b-th>
                      <b-th
                        rowspan="2"
                        variant="info"
                        width="10%"
                        style="text-align: center; vertical-align: middle"
                      >
                        {{ $t("providertin") }}
                      </b-th>
                      <b-th
                        variant="info"
                        colspan="2"
                        style="text-align: center"
                      >
                        {{ $t("totalcosttotal") }}
                      </b-th>
                      <b-th
                        variant="info"
                        colspan="2"
                        style="text-align: center"
                      >
                        {{ $t("donecosttotal") }}
                      </b-th>
                      <b-th
                        variant="info"
                        colspan="2"
                        style="text-align: center"
                      >
                        {{ $t("paidcosttotal") }}
                      </b-th>
                      <b-th
                        variant="info"
                        colspan="2"
                        style="text-align: center"
                      >
                        {{ $t("newcosttotal") }}
                      </b-th>
                    </tr>
                    <tr>
                      <b-th
                        variant="info"
                        width="6%"
                        style="text-align: center; vertical-align: middle"
                      >
                        {{ $t("Count") }}
                      </b-th>
                      <b-th
                        variant="info"
                        width="10%"
                        style="text-align: center; vertical-align: middle"
                      >
                        {{ $t("Cost") }}
                      </b-th>
                      <b-th
                        variant="info"
                        width="6%"
                        style="text-align: center; vertical-align: middle"
                      >
                        {{ $t("Count") }}
                      </b-th>
                      <b-th
                        variant="info"
                        width="7%"
                        style="text-align: center; vertical-align: middle"
                      >
                        {{ $t("Cost") }}
                      </b-th>
                      <b-th
                        variant="info"
                        width="6%"
                        style="text-align: center; vertical-align: middle"
                      >
                        {{ $t("Count") }}
                      </b-th>
                      <b-th
                        variant="info"
                        width="7%"
                        style="text-align: center; vertical-align: middle"
                      >
                        {{ $t("Cost") }}
                      </b-th>
                      <b-th
                        variant="info"
                        width="6%"
                        style="text-align: center; vertical-align: middle"
                      >
                        {{ $t("Count") }}
                      </b-th>
                      <b-th
                        variant="info"
                        width="9%"
                        style="text-align: center; vertical-align: middle"
                      >
                        {{ $t("Cost") }}
                      </b-th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      v-for="(item, i) in items"
                      style="text-align: center; vertical-align: middle"
                      :key="i"
                    >
                      <td style="text-align: left; vertical-align: middle">
                        <a
                          href="javascript:void(0)"
                          @click="
                            $router.push({
                              name: 'ProviderCard',
                              query: {
                                providerid: item.providerid,
                                providertin: item.providertin
                              }
                            })
                          "
                          >{{ item.providername }}</a
                        >
                      </td>
                      <td style="text-align: left; vertical-align: middle">
                        {{ item.providertin }}
                      </td>
                      <td
                        style=" font-weight:bold; text-align: right; white-space: nowrap"
                      >
                        {{
                          $options.filters.currency(item.totalcount, {
                            symbol: "",
                            fractionCount: 0
                          })
                        }}
                      </td>
                      <td
                        style="font-weight:bold; text-align: right; white-space: nowrap"
                      >
                        {{
                          $options.filters.currency(item.totalcost, {
                            symbol: "",
                            fractionCount: 0
                          })
                        }}
                      </td>
                      <td style="text-align: right; white-space: nowrap">
                        {{
                          $options.filters.currency(
                            item.awaitingmoderationcount,
                            {
                              symbol: "",
                              fractionCount: 0
                            }
                          )
                        }}
                      </td>
                      <td style="text-align: right; white-space: nowrap">
                        {{
                          $options.filters.currency(
                            item.awaitingmoderationcost,
                            {
                              symbol: "",
                              fractionCount: 0
                            }
                          )
                        }}
                      </td>
                      <td style="text-align: right; white-space: nowrap">
                        {{
                          $options.filters.currency(item.donecount, {
                            symbol: "",
                            fractionCount: 0
                          })
                        }}
                      </td>
                      <td style="text-align: right; white-space: nowrap">
                        {{
                          $options.filters.currency(item.donecost, {
                            symbol: "",
                            fractionCount: 0
                          })
                        }}
                      </td>
                      <td style="text-align: right; white-space: nowrap">
                        {{
                          $options.filters.currency(item.notdonecount, {
                            symbol: "",
                            fractionCount: 0
                          })
                        }}
                      </td>
                      <td style="text-align: right; white-space: nowrap">
                        {{
                          $options.filters.currency(item.notdonecost, {
                            symbol: "",
                            fractionCount: 0
                          })
                        }}
                      </td>
                    </tr>
                    <tr
                      style="
                  text-align: right;
                  vertical-align: middle;
                  font-weight: bold;
                "
                    >
                      <td>{{ $t("Total") }}</td>
                      <td style="white-space: nowrap">
                        {{
                          total.totaltotalcount == 0
                            ? "-"
                            : $options.filters.currency(total.totaltotalcount, {
                                symbol: "",
                                fractionCount: 0
                              })
                        }}
                      </td>
                      <td style="white-space: nowrap">
                        {{
                          total.totaltotalcost == 0
                            ? "-"
                            : $options.filters.currency(total.totaltotalcost, {
                                symbol: "",
                                fractionCount: 0
                              })
                        }}
                      </td>
                      <td style="white-space: nowrap">
                        {{
                          total.totaldonecount == 0
                            ? "-"
                            : $options.filters.currency(total.totaldonecount, {
                                symbol: "",
                                fractionCount: 0
                              })
                        }}
                      </td>
                      <td style="white-space: nowrap">
                        {{
                          total.totaldonecost == 0
                            ? "-"
                            : $options.filters.currency(total.totaldonecost, {
                                symbol: "",
                                fractionCount: 0
                              })
                        }}
                      </td>
                      <td style="white-space: nowrap">
                        {{
                          total.totalpaidcount == 0
                            ? "-"
                            : $options.filters.currency(total.totalpaidcount, {
                                symbol: "",
                                fractionCount: 0
                              })
                        }}
                      </td>
                      <td style="white-space: nowrap">
                        {{
                          total.totalpaidcost == 0
                            ? "-"
                            : $options.filters.currency(total.totalpaidcost, {
                                symbol: "",
                                fractionCount: 0
                              })
                        }}
                      </td>
                      <td style="white-space: nowrap">
                        {{
                          total.totalnotdonecount == 0
                            ? "-"
                            : $options.filters.currency(
                                total.totalnotdonecount,
                                {
                                  symbol: "",
                                  fractionCount: 0
                                }
                              )
                        }}
                      </td>
                      <td style="white-space: nowrap">
                        {{
                          total.totalnewcost == 0
                            ? "-"
                            : $options.filters.currency(total.totalnewcost, {
                                symbol: "",
                                fractionCount: 0
                              })
                        }}
                      </td>
                    </tr>
                  </tbody>
                  <!-- <tbody >
              <tr>
                <td class="text-center" colspan="19">
                  <b-spinner></b-spinner>
                </td>
              </tr>
            </tbody> -->
                </table>

                <br />
              </div>
            </div>
            <!-- <div>
            <b-row class="m-2">
              <b-col
                cols="12"
                sm="6"
                class="
                  d-flex
                  align-items-center
                  justify-content-center justify-content-sm-start
                "
              >
                <span class="text-muted">
                  {{ $t("Showing") }} {{ firstNumber }} {{ $t("to")
                  }}{{ lastNumber }} {{ $t("of") }}{{ filter.totalRows
                  }}{{ $t("entries") }}
                </span>
              </b-col>
              <b-col
                cols="12"
                sm="6"
                class="
                  d-flex
                  align-items-center
                  justify-content-center justify-content-sm-end
                "
              >
                <b-pagination
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
                  @input="Refresh"
                  :per-page="filter.PageLimit"
                  :total-rows="filter.totalRows"
                  v-model="filter.PageNumber"
                >
                  <template #prev-text>
                    <i class="fas fa-angle-left"></i>
                  </template>
                  <template #next-text>
                    <i class="fas fa-angle-right"></i>
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div> -->
          </div>
        </div>
      </div>
    </b-overlay>
  </Layout>
</template>

<script>
import Layout from "@/router/layouts/main";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import PageHeader from "@/components/page-header";
import ReportService from "@/services/reports/report.service";
import CustomDatePicker from "../../../components/customDatePicker.vue";

export default {
  components: { Layout, PageHeader, Multiselect, DatePicker, CustomDatePicker },
  data() {
    return {
      title: this.$t("GetTopMaxLotCountAuctionInfoByProviderPlatformAuction"),
      braedcrumb: [
        {
          text: this.$t("Reports")
        },
        {
          text: this.$t(
            "GetTopMaxLotCountAuctionInfoByProviderPlatformAuction"
          ),
          active: true
        }
      ],
      isLoading: false,
      filter: {
        StartDate: "",
        EndDate: "",
        ProviderId: 0,
        OblastID: 0,
        RegionId: 0,
        perPageOptions: [10, 20, 50, 100],
        totalRows: 0
      },
      total: {
        totalawaitingmoderationcount: 0,
        totalawaitingmoderationcost: 0,
        totaldonecount: 0,
        totaldonecost: 0,
        totalnotdonecount: 0,
        totalnotdonecost: 0,
        totaltotalcount: 0,
        totaltotalcost: 0
      },
      fields: [
        {
          key: "providername",
          label: this.$t("provider"),
          sort: true,
          tdClass: "text-left",
          thClass: "text-center",
          thStyle: { width: "5% !important" }
        },
        {
          key: "providertin",
          label: this.$t("providertin"),
          sort: true,
          tdClass: "text-left",
          thClass: "text-center",
          thStyle: { width: "5% !important" }
        },
        {
          key: "notpaidcosttotal",
          label: this.$t("notpaidcosttotal"),
          sort: true,
          tdClass: "text-right",
          thClass: "text-center",
          thStyle: { width: "15% !important" }
        },
        {
          key: "notdeliveredcosttotal",
          label: this.$t("notdeliveredcosttotal"),
          sort: true,
          tdClass: "text-right",
          thClass: "text-center",
          thStyle: { width: "15% !important" }
        },
        {
          key: "newcosttotal",
          label: this.$t("newcosttotal"),
          tdClass: "text-right",
          thClass: "text-center",
          sort: true,
          thStyle: { width: "15% !important" }
        },
        {
          key: "totalcosttotal",
          label: this.$t("totalcosttotal"),
          sort: true,
          tdClass: "text-right",
          thClass: "text-center",
          thStyle: { width: "15% !important" }
        }
      ],
      items: [],
      OblastList: [],
      RegionList: [],
      isBusy: false,
      PrintLoading: false
    };
  },
  computed: {
    firstNumber() {
      return (this.filter.PageNumber - 1) * this.filter.PageLimit + 1;
    },
    lastNumber() {
      if (this.filter.totalRows < this.filter.PageLimit) {
        return this.filter.totalRows;
      } else {
        if (
          this.filter.PageNumber * this.filter.PageLimit >
          this.filter.totalRows
        ) {
          return this.filter.totalRows;
        } else {
          return this.filter.PageNumber * this.filter.PageLimit;
        }
      }
    }
  },
  created() {
    var today = new Date();
    var todaydate = new Date();
    var dd = String(todaydate.getDate()).padStart(2, "0");
    var mn = String(todaydate.getMonth() - 1).padStart(2, "0");
    var mm = String(todaydate.getMonth() + 1).padStart(2, "0");
    var yyyy = todaydate.getFullYear();
    var day =
      today.getDate() +
      "." +
      (today.getMonth() + 1) +
      "." +
      today.getFullYear();
    this.filter.StartDate = "01" + "." + "01" + "." + yyyy;
    this.filter.EndDate = dd + "." + mm + "." + yyyy;
    if (
      this.$store.state.TopMaxLotCountAuctionInfoByProviderPlatformAuction
        .StartDate != undefined
    ) {
      this.filter = this.$store.state.TopMaxLotCountAuctionInfoByProviderPlatformAuction;
    }
    this.Refresh();
    // UzexService.GetAllAuctionOblast().then((res) => {
    //   this.OblastList = res.data.result;
    // });
  },
  mounted() {
    var tableHeaderTop = document
      .querySelector(".stikcy-header thead")
      .getBoundingClientRect().top;
    // console.log(tableHeaderTop)
    var ths = document.querySelectorAll(".stikcy-header thead th");

    for (var i = 0; i < ths.length; i++) {
      var th = ths[i];
      th.style.top = th.getBoundingClientRect().top - tableHeaderTop + "px";
    }
  },
  methods: {
    BindValueStart(value) {
      this.filter.StartDate = value;
    },
    BindValueEndDate(value) {
      this.filter.EndDate = value;
    },
    calculate() {
      this.total = {
        totalawaitingmoderationcount: 0,
        totalawaitingmoderationcost: 0,
        totaldonecount: 0,
        totaldonecost: 0,
        totalnotdonecount: 0,
        totalnotdonecost: 0,
        totaltotalcount: 0,
        totaltotalcost: 0
      };
      for (var i = 0; i < this.items.length; i++) {
        this.total.totalawaitingmoderationcount +=
          1 * this.items[i].awaitingmoderationcount;
        this.total.totalawaitingmoderationcost +=
          1 * this.items[i].awaitingmoderationcost;
        this.total.totaldonecount += 1 * this.items[i].donecount;
        this.total.totaldonecost += 1 * this.items[i].donecost;
        this.total.totalnotdonecount += 1 * this.items[i].notdonecount;
        this.total.totalnotdonecost += 1 * this.items[i].notdonecost;
        this.total.totaltotalcount += 1 * this.items[i].totalcount;
        this.total.totaltotalcost += 1 * this.items[i].totalcost;
      }
    },
    SortChange(data) {
      this.filter.SortColumn = data.sortBy;
      this.filter.OrderType = data.sortDesc ? "desc" : "asc";
      this.Refresh();
    },
    saveFilter() {
      this.$store.state.TopMaxLotCountAuctionInfoByProviderPlatformAuction = this.filter;
    },
    forceFileDownload(response, name) {
      var headers = response.headers;
      var blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      link.setAttribute("download", name + ".xlsx"); //or any other extension
      document.body.appendChild(link);
      link.click();
    },
    Print() {
      this.PrintLoading = true;
      ReportService.PrintTopMaxLotCountAuctionInfoByProviderPlatformAuction(
        this.filter.StartDate,
        this.filter.EndDate
      )
        .then(response => {
          this.PrintLoading = false;
          this.forceFileDownload(
            response,
            this.$t("GetTopMaxLotCountAuctionInfoByProviderPlatformAuction")
          );
        })
        .catch(e => {
          this.PrintLoading = false;
          let response = JSON.parse(e.request.response);

          self.makeToast(response.error, self.$t("actions.error"), "danger");
        });
    },
    Refresh() {
      this.isBusy = true;
      this.saveFilter();
      ReportService.GetTopMaxLotCountAuctionInfoByProviderPlatformAuction(
        this.filter.StartDate,
        this.filter.EndDate
      )
        .then(res => {
          this.items = res.data.result;
          this.filter.totalRows = res.data.total;
          this.isBusy = false;
          this.calculate();
        })
        .catch(error => {
          this.isBusy = false;
          this.$notification(error.response.data.error, "danger");
        });
    }
    // OblastChange() {
    //   this.filter.RegionId = 0;
    //   if (!!this.filter.OblastId) {
    //     UzexService.GetAllAuctionRegion(this.filter.OblastId).then((res) => {
    //       this.RegionList = res.data.result;
    //     });
    //     this.Refresh();
    //   }
    // },
    // topCountryChange() {
    //   this.filter.oblastname = "";
    //   this.filter.OblastId = 0;
    //   this.fields[0].key = "oblastname";
    //   this.fields[0].label = this.$t("Oblast");
    //   this.Refresh();
    // },
    // topOblastChange() {
    //   this.filter.regionname = "";
    //   this.filter.RegionId = 0;
    //   this.fields[0].key = "regionname";
    //   this.fields[0].label = this.$t("Region");
    //   this.Refresh();
    // },
    // ChangeOblast(item) {
    //   this.filter.OblastId = item.oblastid;
    //   this.fields[0].key = "regionname";
    //   this.filter.oblastname = item.oblastname;
    //   this.fields[0].label = this.$t("Region");
    //   this.Refresh();
    // },
    // ChangeRegion(item) {
    //   this.$router.push({ name: "AuctionLotInfo",
    //   query: {
    //           oblastid: item.oblastid,
    //           regionid: item.regionid,
    //         },
    //          });
    // },
  }
};
</script>

<style lang="scss">
.text-right {
  text-align: right;
}
</style>
